(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        return {
            responseError: responseError
        };

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('eDocumentsApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
